import { memo } from "react";
import { Box, Typography } from "@mui/material";
import parse from "html-react-parser";
import { IQuoteFormStepper } from "../../../../types/quoteFormTypes";
import TickIcon from "../../../../assets/svg-fc/TickIcon";
import "./quoteFormMobileStepper.scss";

const QuoteFormMobileStepper = ({ steps, disabled, onClickStep }: IQuoteFormStepper) => {
	return (
		<Box className="quoteFormMobileStepper">
			{steps.map(({ step, title, isActive, isCompleted }) => {
				return (
					<Box key={step} className="horizontalStepContainer">
						<Box
							className={`horizontalStep ${disabled ? "disabled" : isActive ? "active" : isCompleted ? "completed" : "upcoming"}`}
							onClick={() => !disabled && isCompleted && onClickStep(step)}
						>
							<Box className="horizontalStepCircle">
								{isCompleted ? <TickIcon /> : step}
							</Box>
							<Typography className="horizontalStepLabel">{parse(title)}</Typography>
						</Box>
					</Box>
				);
			})}
		</Box>
	);
};

export default memo(QuoteFormMobileStepper);
